import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import PropTypes from "prop-types";

import SortAZ from "@/svgs/sort-alpha-down.svg";
import SortZA from "@/svgs/sort-alpha-up.svg";

function UsersTableHead({ order, orderBy, sortHandler }) {
  const labels = ["name", "email", "role", "manage"];

  return (
    <TableHead id="users-table-header">
      <TableRow>
        {labels.map((label, index) => {
          if (label === "manage") {
            return (
              <TableCell
                key={`users-table-head-cell-${index}`}
                className="dashboardstyle-tableHead users-table-column-header"
              >
                {" "}
                manage{" "}
              </TableCell>
            );
          }

          return (
            <TableCell
              key={`users-table-head-cell-${index}`}
              sortDirection={orderBy === label ? order : false}
            >
              <TableSortLabel
                active={orderBy === label}
                direction={orderBy === label ? order : "asc"}
                onClick={() => sortHandler(label)}
                className="dashboardstyle-tableHead users-table-column-header"
              >
                {label}
                <img
                  src={order === "asc" ? SortAZ : SortZA}
                  className={`users-table-svg ${
                    orderBy !== label ? "users-svg-hide" : ""
                  }`}
                  alt="Sort users"
                />
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

UsersTableHead.propTypes = {
  order: PropTypes.string,
  orderBy: PropTypes.string,
  sortHandler: PropTypes.func,
  user: PropTypes.object,
};
export default UsersTableHead;
